/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable react/prop-types */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { FaLaptop } from '@react-icons/all-files/fa/FaLaptop';
import { FaDesktop } from '@react-icons/all-files/fa/FaDesktop';
import { FaPlane } from '@react-icons/all-files/fa/FaPlane';
import { FaChevronCircleRight } from '@react-icons/all-files/fa/FaChevronCircleRight';

import { getSectionExtraField, translate } from 'gatsby-core-theme/src/helpers/getters';
import Button from 'gatsby-core-theme/src/components/atoms/button';
import { Context } from '~context/TranslationsProvider';
import { getFeaturedEvent } from '../../../../helpers/events';
import styles from './schedule-box.module.scss';

const ScheduleBox = ({ section, category = 'soccer' }) => {
  const { translations } = useContext(Context) || {};
  const header = section?.page?.sections?.header;
  const headerBoxTitle = getSectionExtraField(null, header, 'header_box_title');
  const headerBoxSubitle = getSectionExtraField(null, header, 'header_box_subtitle');
  const featuredEvent = getFeaturedEvent(section?.page?.relation);

  return (
    <div className={`${styles.scheduleBox} ${styles[category]}`}>
      <div className={styles.boxTop}>
        <h2 className={styles.boxTitle}>{headerBoxTitle}</h2>
        <p>{headerBoxSubitle}</p>
        <p className={styles.boxIcons}>
          <FaLaptop />
          {translate(translations, 'live_on_tv', 'Live on TV')}
        </p>
        <p className={`${styles.boxIcons} ${styles.planeIcon}`}>
          <FaPlane />
          {translate(translations, 'live_at_stadium', 'Live at Stadium')}
        </p>
        <p className={styles.boxIcons}>
          <FaDesktop />
          {translate(translations, 'watch_online', 'Watch Online')}
        </p>
        <p className={styles.zero}>
          {translate(translations, 'on_pc_mobile_tablet', 'on PC, Mobile and Tablet.')}
        </p>
      </div>
      {featuredEvent && (
        <div className={styles.boxBottom}>
          <p>
            {translate(translations, 'next_match_watch_today', 'Next top match - Watch today:')}
            <br />
            <strong>
              {translate(translations, 'at', 'at.')}
              {` ${featuredEvent?.date?.time}: ${featuredEvent?.home_team?.name} vs ${featuredEvent?.away_team?.name}`}
            </strong>
          </p>

          <Button
            to={featuredEvent.path}
            className={category}
            isInternalLink
            btnText={
              <>
                <FaChevronCircleRight />
                {` ${translate(translations, 'watch', 'watch')} ${
                  featuredEvent?.home_team?.name
                } vs ${featuredEvent?.away_team?.name}`}
              </>
            }
            gtmClass="schedule-box-gtm btn-cta"
          />
        </div>
      )}
    </div>
  );
};

ScheduleBox.propTypes = {
  section: PropTypes.shape({
    page: PropTypes.shape({
      relation: PropTypes.shape({}),
      template: PropTypes.string,
      path: PropTypes.string,
      updated_at: PropTypes.string,
      created_at: PropTypes.string,
      author: PropTypes.shape({
        name: PropTypes.string,
        profile_page_path: PropTypes.string,
      }),
      sections: PropTypes.shape({
        header: PropTypes.shape({
          extra_fields: PropTypes.shape({
            header_background_image: PropTypes.oneOfType([
              PropTypes.string,
              PropTypes.shape({
                value: PropTypes.string,
                type: PropTypes.string,
              }),
            ]),
            header_content: PropTypes.oneOfType([
              PropTypes.string,
              PropTypes.shape({
                value: PropTypes.string,
                type: PropTypes.string,
              }),
            ]),
          }),
        }),
      }),
      title: PropTypes.string,
    }),
  }).isRequired,
  category: PropTypes.string,
};

export default ScheduleBox;
